<template>
  <v-card data-testid="tool_slap_tap">
    <v-card-title style="padding: 0px">
      <v-toolbar grey flat>
        <v-btn icon @click="close" data-testid="tool_slap_tap_close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t("common.slap_tap") }}</v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-container>
        <v-select v-model="difficulty" :items="difficulty_options" :label="$t('common.difficulty')" />
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="view()" data-testid="tool_slap_tap_view">{{ $t("common.view") }}</v-btn>
      <v-btn @click="download()" data-testid="tool_slap_tap_download">{{ $t("common.download") }}</v-btn>
      <v-btn @click="print_key()" data-testid="tool_slap_tap_print_key">{{ $t("tool_slap_tap.print_key") }}</v-btn>
      <v-spacer />
      <v-btn color="primary" @click="print()" data-testid="tool_slap_tap_print">{{ $t("common.print") }}</v-btn>
    </v-card-actions>
    <v-progress-linear v-if="in_flight" :indeterminate="true" />
  </v-card>
</template>

<script>
import printJS from "print-js";
import { Chance } from "chance";
let chance = Chance();

export default {
  components: {},
  props: {},
  data() {
    let data = {
      difficulty: "easy",
      difficulty_options: [
        { text: this.$t("common.easy"), value: "easy" },
        { text: this.$t("common.medium"), value: "med" },
        { text: this.$t("common.hard"), value: "hard" },
      ],
      in_flight: false,
    };
    return data;
  },
  methods: {
    view: function () {
      window.open(this.url(true), "_blank");
    },
    download() {
      window.open(this.url(false, true), "_blank");
    },
    url(rotate = false, download = false) {
      let uri = "/api/tools/pdf/picture_grid/slap_tap_" + this.difficulty;
      uri += "/picture_grid.pdf?rows=11&cols=6&size=75&padding_sides=20&margin_top=20";
      uri += "&cache_buster=" + chance.hex();

      if (rotate) {
        uri += "&rotate=90";
      }

      if (download) {
        uri += "&download=true";
      }

      return uri;
    },
    print() {
      let self = this;

      if (navigator.vendor.includes("Apple")) {
        window.open(this.url(), "_blank");
        return;
      }

      printJS({
        printable: this.url(true),
        onLoadingStart: function () {
          self.in_flight = true;
        },
        onLoadingEnd: function () {
          self.in_flight = false;
        },
        style: "@page { size: Letter landscape; }",
      });
    },
    print_key: function () {
      let self = this;

      printJS({
        printable: "/assets/pdfs/static/slap_tap_key.en.pdf",
        onLoadingStart: function () {
          self.in_flight = true;
        },
        onLoadingEnd: function () {
          self.in_flight = false;
        },
        style: "@page { size: Letter landscape; }",
      });
    },
    close: function () {
      this.$emit("close");
    },
  },
};
</script>
